export const name = '_usdcoin'
export const displayName = 'USDC'
export const ticker = `${name}_USDC`
export const displayTicker = 'USDC'
export const units = {
  [`${name}_base`]: 0,
  [ticker]: 8,
}
export const assetType = 'MULTI_NETWORK_ASSET'

export const combinedAssetNames = [
  'usdcoin',
  'usdcoin_algorand',
  'usdcoin_solana',
  'usdcoin_bsc',
  'usdcoin_tron',
  'usdc_matic_0a883d9b',
  'usdc_avalanchec_185c8bd7',
  'usdc_ethereumarbone_2e1129c4',
  'usdc_optimism_68bb70cd',
  'usdc_basemainnet_b5a52617',
]
